import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { ResetComponent } from './reset/reset.component';
import { FirstPasswordComponent } from './first-password/first-password.component';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  // { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetComponent },
  { path: 'first-password', component: FirstPasswordComponent },

  // { path: 'signup', component: RegisterComponent },
  { path: 'signup', component: PaymentDetailsComponent },
  // { path: 'sitemap.xml', component: SitemapComponent },
  // { path: 'robots.txt', component: RobotsComponent },
  // { path: 'setting', component: SettingComponent},
  //  , canActivate: [AuthGuard]
  { path: '**', redirectTo: '/login' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
